import React, { Fragment } from "react";
import "components/Spotlight/Spotlight_Common.css";
import CollapseComponent from "components/Spotlight/CollapseComponent";

class TreasureTrove extends React.Component {
	render() {
		return (
			<Fragment>
				<CollapseComponent
					title={"Treasure Trove"}					
				/>
			</Fragment>
		);
	}
}

export default TreasureTrove;
